import { Injectable, NgZone } from '@angular/core';
import { mergeMapTo, mergeMap, distinctUntilChanged } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { ApiService } from './api.service';
import { Router } from '@angular/router';
import { GenerateRouteService } from './generate-route.service';
import { decodedToken } from '../helpers/token.helper';
import { get } from 'lodash';
import { CurrentUserService } from './current-user.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { UserService } from './user.service';
import { NavigationService } from './navigation.service';

@Injectable()
export class MessagingService {

    currentMessage = new BehaviorSubject(null);
    removeMessage = new BehaviorSubject(null);
    reloadNotificationList = new BehaviorSubject(null);
    users: any = [];
    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService,
        private router: Router,
        private ngZone: NgZone,
        private generateRouteService: GenerateRouteService,
        private currentUserService: CurrentUserService,
        private angularFireMessaging: AngularFireMessaging,
        private userService: UserService,
        private navigationService : NavigationService
      ) {
        this.users = this.currentUserService.users;
        this.permission = this.isSupported() ? 'default' : 'denied';
        this.requestPermissions();
    }


    /**
     * request permission for notification from firebase cloud messaging
     *
     * @param userId userId
     */

    requestPermission(userId) {
        //////console.log("enter FCM")
        this.angularFireMessaging.requestToken.subscribe(
            (token) => {
                //////console.log('-- FCM Token -- ', token);
                const tokens = decodedToken();
                var type = get(tokens, 'type')
                this.sendFCMToken(token);
                if (type == "parent") {
                    this.trackingSendFCMToken(token);
                }
            }, (err) => {
                //////console.error('Unable to get permission to notify.', err);
            }
        );
    }

    sendFCMToken(token) {
        let obj = { token: token }
        return this.httpClient.post(environment.apiURL + 'userUpdateToken', obj)
            .toPromise()
            .then(this.handleData)
            .catch(this.handleError);
    }

    onLogout(){
        return this.httpClient.post(environment.apiURL + 'userUpdateToken', null)
    }

    trackingSendFCMToken(token) {
        const tokens = decodedToken();
        var customerId = get(tokens, 'customer_id')
        var schoolId = get(tokens, 'branch_id')
        var studentId = [];
        this.users.forEach(element => {
            studentId.push(element.student_id);
        });
        let obj = {
            "customerId": String(customerId),
            "schoolId": String(schoolId),
            "studentIds": String(studentId),
            "token": token
        }
        let formData = new FormData();
        formData.append("customerId", customerId ?? '');
        formData.append("schoolId", schoolId ?? '');
        formData.append("studentIds", String(studentId));
        formData.append("token", String(token));
        var url = 'deviceurl' //environment.deviceApiURl;
        return this.httpClient.put(url + 'student/update/token-detail', formData)
            .toPromise()
            .then(this.handleData)
            .catch(this.handleError);
    }

    private handleData(res: any) {
        const body = res;
        return body || {};
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    /**
     * hook method when new notification received in foreground
     */
    receiveMessage() {
        this.angularFireMessaging.messages.subscribe(
            (payload) => {
                //////console.log(payload,'this is from the notification service',payload['notification']);
                
                const notifyMsg = payload['data'];
                if (notifyMsg) {
                    notifyMsg.title = notifyMsg.title ? notifyMsg.title : '';
                    notifyMsg.data = notifyMsg.data ? JSON.parse(notifyMsg.data) : '';
                    this.notify(notifyMsg.title, {
                        body: notifyMsg.body, icon:'favicon.ico',
                        page: notifyMsg.page, data: notifyMsg.data, portal: notifyMsg.portal
                    });
                    this.currentMessage.next(notifyMsg);
                    this.appendQueueCount(1);
                }
                //  else {
                //     let trackingNotify = payload['notification']
                //     this.notify(trackingNotify.title, { body: trackingNotify.body, icon: 'favicon.ico' })
                // }
            });
    }

    appendQueueCount(num) {
        let count;
        this.generateRouteService.getQueueCount()
            .subscribe(res => {
                count = res;
            });
        const append = (num) ? (count + 1) : (count - 1);
        this.generateRouteService.setQueueCount(append);
    }

    requestPermissions(): void {
        let self = this;
        if ('Notification' in window) {
            Notification.requestPermission(function (status) {
                return self.permission = status;
            });
        }
    }

    public permission: Permission;

    public isSupported(): boolean {
        return 'Notification' in window;
    }

    notify(title, options) {
        this.generateNotification(title, options);
    }

    generateNotification(title, options): void {
        let self = this;
        let notify = self.create(title, options).subscribe();
     
        
    }

    create(title: string, options?: PushNotification): any {
        let self = this;
        return new Observable((obs) => {
          
            if (!('Notification' in window)) {
                ////console.log('Notifications are not available in this environment');
                obs.complete();
            }
            if (self.permission !== 'granted') {
                //console.log("The user hasn't granted you permission to send push notifications");
                obs.complete();
            }
            let _notify = new Notification(title, options);
            _notify.onshow = (e) => { return obs.next({ notification: _notify, event: e })};
            _notify.onclick = (e) => {
               
                this.ngZone.run(() => {
                    let parsedData = (options['data']);
                    if (options['portal'] == 'admin') {

                        this.generateRouteService.navigateRouteForAdmin(options['portal'], options['page'], parsedData);
                    } 
                });
            };
            _notify.onerror = (e) => { return obs.error({ notification: _notify, event: e }); };
            _notify.onclose = function () { return obs.complete(); };
        });
    }

}

export declare type Permission = 'denied' | 'granted' | 'default';

export interface PushNotification {
    body?: string;
    icon?: string;
    tag?: string;
    data?: any;
    renotify?: boolean;
    silent?: boolean;
    sound?: string;
    noscreen?: boolean;
    sticky?: boolean;
    dir?: 'auto' | 'ltr' | 'rtl';
    lang?: string;
    vibrate?: number[];
}